import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import {ProgressBarMode} from '@angular/material/progress-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Observable,timer } from 'rxjs';
import { interval } from 'rxjs';
import { ApiService } from 'src/app/api.service';
import { ShowPollResultComponent } from '../show-poll-result/show-poll-result.component';
import * as Highcharts from 'highcharts';
import * as moment from 'moment';
import { ConformationComponent } from '../conformation/conformation.component';
import { DatePipe } from '@angular/common';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { RankedChoiceVotingDialogComponent } from '../ranked-choice-voting-dialog/ranked-choice-voting-dialog.component';
// import * as CanvasJS from './canvasjs.min';
// import CanvasJS from 'canvasjs';





@Component({
  selector: 'app-execute',
  templateUrl: './execute.component.html',
  styleUrls: ['./execute.component.scss'],
  providers: [DatePipe]
})
export class ExecuteComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns: string[] ;
  dataSource :any;
  searchText;
  userInfo = JSON.parse(localStorage.getItem('User'));
  userRole = this.userInfo.roles[0];
  showSpinner = false;
  filteredpollHistoryList = [];
  campaignOne: FormGroup;
  campaignTwo: FormGroup;
  
  executionHistory = [];
  executionHistoryTableData = [];
  color: ThemePalette = 'primary';
  mode: ProgressBarMode = 'buffer';
  value = 0;
  phone;
  phoneNumber = new FormGroup({
    phone: new FormControl('')
  });
  phoneNumberList = [];
  phoneNumberObjectList = [];
  screenwidth =null;
  dialogwidth = null;
  pollId = this.route.snapshot.paramMap.get('pollId');
  pollInfo;
  myDate = new Date();

  constructor(private dialog: MatDialog,
    private _apiService: ApiService,
    private route: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private datePipe: DatePipe
    ) {
      const today = new Date();
      const month = today.getMonth();
      const year = today.getFullYear();
      const day = today.getDate()
      this.campaignOne = new FormGroup({
        start: new FormControl(new Date(year, month, day-5)),
        end: new FormControl(new Date(year, month, day, 23,59))
      });
  }

  ngOnInit(): void {
    debugger;
    this.screenwidth = screen.width;
    if(this.screenwidth < 500){
      this.dialogwidth = '90%';
    }else{
      this.dialogwidth = '50%';
    }

    if(this.userRole =='admin'){
      this.displayedColumns = ['created_at', 'completed', 'id', 'updated_at'];
    }else if(this.userRole =='manager'){
      this.displayedColumns = ['created_at', 'completed', 'updated_at'];
    }

    this._apiService.getSpecificPollInfo(this.pollId).subscribe(res => {
      if (res) {
        debugger;
        console.log(res);
        this.pollInfo = res;
      } 
    },
    (error)=>{
      console.log(error);
    });

    this.refreshPollExecutionHistory();

    this._apiService.companyInfo().subscribe(res => {
      if (res.numbers) {
        this.phoneNumberList = res.numbers;
        for(let i=0;i<this.phoneNumberList.length;i++){
          let tdInstance ={phone:this.phoneNumberList[i].split("/")[0] , description:this.phoneNumberList[i].split("/")[1]};
          this.phoneNumberObjectList.push(tdInstance);
        }
      } 
    },
    (error)=>{
      console.log(error);
    });

  }

  refreshPollExecutionHistory(){
    
    this.showSpinner = true;
    this._apiService.getPollExecutionHistory(this.pollId).subscribe(res => {
      if (res) {
        console.log(res)
        this.showSpinner = false;
        this.executionHistory = res;
        this.executionHistoryTableData = [];
        // for(let i=0;i<this.executionHistory.length;i++){
        //   let instance = {completed:this.executionHistory[i].completed,id:this.executionHistory[i].id};
        //   instance['date'] = moment(this.executionHistory[i].created_at).format('YYYY-MM-DD');
        //   instance['time'] = moment(this.executionHistory[i].created_at).format('HH:mm');
        //   this.executionHistoryTableData.push(instance);
        //   this.executionHistoryTableData.reverse();
        // }
        // this.executionHistory.reverse();
        console.log('executionHistory',this.executionHistory)
        this.filteredpollHistoryListOnBasisOfDateRange();
        
      } 
    },
    (error)=>{
      this.showSpinner = false;
      console.log(error);
    });
  }

  filteredpollHistoryListOnBasisOfDateRange(){
    debugger;
    if(this.campaignOne.get('start') == null && this.campaignOne.get('end')){
      this.filteredpollHistoryList = this.executionHistory;
    }
    let startdate = this.datePipe.transform(this.campaignOne.get('start').value, 'yyyy-MM-dd, h:mm a');
    let enddate = this.datePipe.transform(this.campaignOne.get('end').value, 'yyyy-MM-dd, h:mm a');
    this.filteredpollHistoryList = this.executionHistory.filter(ele => moment(ele.created_at).format('YYYY-MM-DD') >= startdate && moment(ele.created_at).format('YYYY-MM-DD')  <= enddate);
    console.log(this.filteredpollHistoryList)
    this.dataSource = new MatTableDataSource<pollHistoryList>(this.filteredpollHistoryList);
    
    setTimeout(() => this.dataSource.paginator = this.paginator);
    setTimeout(() => this.dataSource.sort = this.sort);
  }


  executeNow(){
    
    let pollData = {
    "phone_number":this.phone,
    "poll_id":this.pollInfo.id
    }   
    console.log(pollData);
    this._apiService.executePoll(pollData).subscribe(res => {
      if (res) {
        console.log(res);
        this.phone = '';
        this.refreshPollExecutionHistory();
      } 
    },
    (error)=>{
      console.log(error);
    });
    
  }

  deletePollHistory(id){
    const dialogRef = this.dialog.open(ConformationComponent, {
      width: '20rem',
      data: {id: id,type:'Poll Result'}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.refreshPollExecutionHistory();
    });
  }


  ngOnDestroy(){
  console.log("Destroy timer");
    
  }

  openDialog(id): void {
    if(this.pollInfo.poll_type == 'ranked-choice'){
      const dialogRef = this.dialog.open(RankedChoiceVotingDialogComponent, {
        width: this.dialogwidth,
        data: {id:id}
      });
  
      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
        this.refreshPollExecutionHistory();
      });
    }else {
      const dialogRef = this.dialog.open(ShowPollResultComponent, {
        width: this.dialogwidth,
        data: {id:id}
      });
  
      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
        this.refreshPollExecutionHistory();
      });
    }
    
  }

}

export interface pollHistoryList {
  completed: boolean;
  poll_id: number;
  id: number;
  created_at: string;
  company_id: number;
  expiry: number;
  updated_at:string;
};
